import Layout from "../../components/Layout/Layout";
import { useEpaperPage } from "./hooks/useEpaperPage";
import PdfPreviewModal from "./components/PdfPreviewModal";
import DashboardAlerts from "./components/DashboardAlerts";
import DashboardFilters from "./components/DashboardFilters";
import SummaryCards from "./components/SummaryCards";
import StatusStrips from "./components/StatusStrips";
import EditionsTable from "./components/EditionsTable";
import EditionsPagination from "./components/EditionsPagination";

export default function EpaperEditions() {
  const { dashboard, updates } = useEpaperPage();

  return (
    <Layout bodynew>
      <main className="mx-auto max-w-7xl px-4 py-3 sm:px-6 lg:px-8">
        <PdfPreviewModal
          isOpen={updates.previewModal.isOpen}
          previewModal={updates.previewModal}
          isPageSliding={updates.isPageSliding}
          pageSlideDirection={updates.pageSlideDirection}
          onClose={updates.closePreview}
          onPrevPage={updates.handlePreviewPrev}
          onNextPage={updates.handlePreviewNext}
        />

        <section className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5">
          <DashboardAlerts
            conflictMessage={updates.updateConflictMessage}
            isWaiting={updates.isWaitingForDashboard}
            onDismissConflict={updates.dismissConflictMessage}
          />
          <DashboardFilters
            rangeLabel={dashboard.rangeLabel}
            rangeFrom={dashboard.rangeFrom}
            selectedRange={dashboard.selectedRange}
            visibleMonth={dashboard.visibleMonth}
            isCalendarOpen={dashboard.isCalendarOpen}
            status={dashboard.status}
            search={dashboard.search}
            isMultiDayRange={dashboard.isMultiDayRange}
            onToggleCalendar={dashboard.toggleCalendar}
            onMonthChange={dashboard.setVisibleMonth}
            onSelectRange={dashboard.handleSelectRange}
            onCloseCalendar={dashboard.closeCalendar}
            onClearFilters={dashboard.clearFilters}
            onStatusChange={dashboard.handleStatusChange}
            onSearchChange={dashboard.handleSearchChange}
          />
          <SummaryCards cards={dashboard.cards} />
          <StatusStrips
            summaryFailedCount={dashboard.summaryFailedCount}
            summaryNotPublishedCount={dashboard.summaryNotPublishedCount}
            stalePendingCount={dashboard.stalePendingIds.length}
          />
        </section>

        <section className="mt-6 rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="border-b border-gray-100 px-4 py-4 sm:px-6">
            <h1 className="text-3xl font-bold text-gray-900">ePaper Editions</h1>
            <p className="mt-1 text-sm text-gray-500">
              Showing 1-{dashboard.editions.length} of {dashboard.totalEditions || dashboard.editions.length}{" "}
              editions for {dashboard.rangeLabel}
            </p>
          </div>
          {dashboard.fetchError ? (
            <p className="px-6 pb-3 text-sm text-red-600" role="alert">
              {dashboard.fetchError}
            </p>
          ) : null}
          {!dashboard.fetchError && dashboard.emptyMessage ? (
            <p className="px-6 pb-3 text-sm text-gray-500">{dashboard.emptyMessage}</p>
          ) : null}

          <EditionsTable
            isLoading={dashboard.isLoading}
            filteredEditions={dashboard.editions}
            emptyMessage={dashboard.emptyMessage}
            onOpenPreview={updates.openPreview}
            onUpdateSingle={updates.handleUpdateSingle}
            updatingEditionId={updates.updatingEditionId}
            disableUpdates={dashboard.isMultiDayRange}
          />
          <EditionsPagination
            showPagination={!dashboard.isLoading && dashboard.editions.length > 0}
            page={dashboard.page}
            totalPages={dashboard.totalPages}
            visiblePageNumbers={dashboard.visiblePageNumbers}
            lastSyncAt={dashboard.lastSyncAt}
            onPrev={dashboard.goToPrevPage}
            onNext={dashboard.goToNextPage}
            onGoToPage={dashboard.setPage}
          />
        </section>
      </main>
    </Layout>
  );
}
